export default "<p>fmthk works!</p>\n"